export default {
  removeEmptyChildren(item) {
    item.forEach((item) => {
      if (!item.children) {
        delete item.children;
      } else {
        this.removeEmptyChildren(item.children);
      }
    });
  },

  fixNodeParent(nodes) {
    console.debug("fixNodeParent");
    this.wtravelAll(nodes, false, (module) => {
      if (!this.emptyArray(module.children)) {
        module.children.forEach((item) => {
          item.parent = module;
        });
      }
    });
  },

  // 广度优先遍历
  wtravelAll(nodes, childrenOnly, callback) {
    const queue = [...nodes];
    this.doWTravel(queue, childrenOnly, callback);
  },

  // 广度优先遍历
  wtravel(rootNode, childrenOnly, callback) {
    if (!rootNode) {
      return;
    }
    if (this.emptyArray(rootNode.children)) {
      callback(rootNode);
      return;
    }
    const queue = [rootNode];
    this.doWTravel(queue, childrenOnly, callback);
  },

  doWTravel(queue, childrenOnly, callback) {
    while (queue.length > 0) {
      const node = queue.shift();
      if (this.emptyArray(node.children)) {
        callback(node);
      } else {
        if (!childrenOnly) {
          callback(node);
        }
        queue.push(...node.children);
      }
    }
  },

  makeFilterTree(nodes, filterCB) {
    // 先重置各个节点的 _visible 值
    this.wtravelAll(nodes, false, (node) => {
      if (filterCB(node)) {
        node.__visible = true;
        this._makeParentVisible(node);
      } else {
        node.__visible = false;
      }
    });
    const filteredNodes = nodes.filter((node) => node.__visible);
    console.debug("filterNodes", filteredNodes.length);

    // 下面的处理，要对非叶子节点进行一次深拷贝，以防止修改原数组的 children，造成层级关系丢失.
    // 但叶子节点又不能拷贝
    const rootNodes = [];
    filteredNodes.forEach((item) => rootNodes.push({ ...item }));

    // 只保留 _visible = true 的节点
    const queue = [...rootNodes];
    while (queue.length > 0) {
      const node = queue.shift();
      if (!this.emptyArray(node.children)) {
        const children = node.children.filter((node) => node.__visible);
        node.children = [];
        children.forEach((item) => node.children.push({ ...item }));
      }
      if (!this.emptyArray(node.children)) {
        queue.push(...node.children);
      }
    }
    return rootNodes;
  },

  _makeParentVisible(node) {
    let parent = node.parent;
    while (parent) {
      parent.__visible = true;
      parent = parent.parent;
    }
  },

  emptyArray(array) {
    return !array || array.length === 0;
  },

  findPathInTree(tree, fieldName, childrenName, value) {
    function recursiveSearch(nodes, path) {
      for (let node of nodes) {
        let currentPath = [...path, node];
        if (node[fieldName] === value) {
          return currentPath;
        }
        if (node[childrenName]) {
          let result = recursiveSearch(node[childrenName], currentPath);
          if (result) {
            return result;
          }
        }
      }
      return null;
    }

    return recursiveSearch(tree, []);
  },

  findInTree(tree, fieldName, childrenName, value, formatValFn) {
    let count = 0;
    console.log("findInTree", tree);
    function exec(tree) {
      count++;
      if (count > 3000) {
        console.warn("findInTree函数执行次数超过3000！请检查数据是否有循环引用");
        return null;
      }
      if (value === undefined) return null;
      for (const node of tree) {
        if ((formatValFn ? formatValFn(node[fieldName]) : node[fieldName]) === value) {
          return node;
        }
        if (node[childrenName]) {
          const result = exec(node[childrenName]);
          if (result) {
            return result;
          }
        }
      }
      return null;
    }
    try {
      return exec(tree);
    } catch (error) {
      console.error(error);
      return null;
    }
  }
};
